import { Suspense, memo } from 'react';
import { TComponentRender } from '../types';
import { importComponent } from '@apia/components';

export const MessageBlock = memo(
  ({ componentData }: { componentData: TComponentRender }) => {
    if (typeof componentData.args === 'string') {
      componentData.args = JSON.parse(componentData.args);
    }

    const Component = importComponent(componentData.path);
    return (
      <Suspense fallback={null}>
        <Component {...componentData.args} />
      </Suspense>
    );
  },
);
